var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1706511485681,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4785,
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M910.020859 397.94086C910.020859 178.510591 731.502268 0 512.079999 0 292.673731 0 114.171139 178.510591 114.291138 395.252881c-0.247998 2.831978-2.167983 28.727773 6.37595 72.663427a393.996891 393.996891 0 0 0 15.087881 58.455539c35.391721 111.103123 128.198988 286.35774 369.397085 490.40413a30.46376 30.46376 0 0 0 19.743844 7.223943c7.471941 0 14.935882-2.719979 20.791836-8.159936 249.382032-231.246175 330.973388-418.508698 355.557195-534.931779l1.311989-6.807946c7.967937-40.711679 7.58394-66.543475 7.463941-76.159399z m-67.951463 66.719474l-0.711995 3.70397c-18.103857 85.775323-83.447342 260.877942-317.389495 483.948182-214.726306-186.870525-297.989649-344.237284-330.133395-445.148488a335.117356 335.117356 0 0 1-13.023898-50.415602c-6.959945-35.839717-5.583956-56.151557-5.471957-58.807536 0-185.694535 151.062808-336.773343 336.741343-336.773343 185.710535 0 336.773343 151.078808 336.805343 338.773327 0.087999 6.895946 0.383997 27.91978-6.815946 64.71949z",
    fill: "#838384",
    "p-id": 4786
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.024 231.254175c-102.447192 0-185.798534 83.359342-185.798534 185.798534 0 102.447192 83.351342 185.798534 185.798534 185.798534 102.439192 0 185.798534-83.351342 185.798534-185.798534 0-102.439192-83.359342-185.798534-185.798534-185.798534z m0 310.429551c-68.727458 0-124.631017-55.903559-124.631017-124.631017 0-68.719458 55.903559-124.631017 124.631017-124.631016 68.719458 0 124.631017 55.911559 124.631016 124.631016 0 68.727458-55.911559 124.631017-124.631016 124.631017z",
    fill: "#838384",
    "p-id": 4787
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.89159a697fd56365fa34429f9f2123b8.svg";
export { ForwardRef as ReactComponent };